new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: false,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    function imageLazyLoad() {
        const lazyImages = document.querySelectorAll('img.banner-lazy[data-src]');

        lazyImages.forEach(function (img) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
            img.classList.add('loaded');
        });
    }

    function loadSvg() {
        const svgs = document.querySelectorAll("[class^='no-svg-']");

        svgs.forEach(function (svg) {
            // Obtém a lista de classes como uma string
            var oldClasses = svg.getAttribute("class");

            // Substitui o prefixo 'no-svg-' por uma string vazia
            var newClasses = oldClasses.replace(/no-svg-/g, '');

            // Define as novas classes para o elemento SVG
            svg.setAttribute("class", newClasses);
        });
    }

    function onFirstScroll() {
        imageLazyLoad();
        loadSvg();
        window.removeEventListener('scroll', onFirstScroll);
    }

    waitForElementToExist('.faixa-comunicado').then(element => {
        const banner = element.querySelector('#faixa-comunicado');

        if (banner) {
            $('#faixa-comunicado').slick({
                arrows: false,
                dots: true,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    window.addEventListener('scroll', onFirstScroll, { passive: true });

    // waitForElementToExist('.rotation-vitrine').then(element => {
    //     $('#carrousel-product-list').slick({
    //         arrows: true,
    //         prevArrow: $(".count .count-prev"),
    //         nextArrow: $(".count .count-next"),
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 700,
    //         responsive: [
    //           {
    //             breakpoint: 992,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //           }
    //         ]
    //     });
    //     $('#carrousel-product-list2').slick({
    //         arrows: true,
    //         prevArrow: $(".count .count-prev2"),
    //         nextArrow: $(".count .count-next2"),
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 700,
    //         responsive: [
    //           {
    //             breakpoint: 992,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //           }
    //         ]
    //     });
    //     $('#carrousel-product-list3').slick({
    //         arrows: true,
    //         prevArrow: $(".count .count-prev3"),
    //         nextArrow: $(".count .count-next3"),
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 700,
    //         responsive: [
    //           {
    //             breakpoint: 992,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //           }
    //         ]
    //     });
    //     $('#carrousel-product-list4').slick({
    //         arrows: true,
    //         prevArrow: $(".count .count-prev4"),
    //         nextArrow: $(".count .count-next4"),
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 700,
    //         responsive: [
    //           {
    //             breakpoint: 992,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //           }
    //         ]
    //     });
    //     $('#carrousel-product-list5').slick({
    //         arrows: true,
    //         prevArrow: $(".count .count-prev5"),
    //         nextArrow: $(".count .count-next5"),
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 700,
    //         responsive: [
    //           {
    //             breakpoint: 992,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //           }
    //         ]
    //     });

    //     if (element) {
    //         let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
    //         let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
    //         initVitrine = Array.from(initVitrine);

    //         if (rotationNames.length && initVitrine.length) {
    //             initVitrine[0].classList.add('active');
    //             rotationNames[0].classList.add('active');

    //             function activeTab(index) {
    //                 initVitrine.forEach((content) => {
    //                     content.classList.remove('active');
    //                 });
    //                 rotationNames.forEach((content) => {
    //                     content.classList.remove('active');
    //                 });
    //                 initVitrine[index].classList.add('active');
    //                 rotationNames[index].classList.add('active');

    //                 // Atualizar classe no contêiner .count
    //                 $('.count').attr('class', function(i, c){
    //                     return c.replace(/(^|\s)count-\S+/g, '');
    //                 }).addClass(`count-${index + 1}`);

    //                 // Refresh slick carousels and bind afterChange event
    //                 const carouselIds = [
    //                     '#carrousel-product-list',
    //                     '#carrousel-product-list2',
    //                     '#carrousel-product-list3',
    //                     '#carrousel-product-list4',
    //                     '#carrousel-product-list5',
    //                 ];
    //                 carouselIds.forEach(id => {
    //                     const $carousel = $(id);
    //                     if ($carousel.hasClass('slick-initialized')) {
    //                         const totalItems = $carousel.slick('getSlick').slideCount;
    //                         const $countFirst = $('.count-content .count-first');
    //                         const $countEnd = $('.count-content .count-end');

    //                         $countEnd.text(('0' + totalItems));
    //                         $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
    //                             $countFirst.text(('0' + (currentSlide + 1)));
    //                         });
    //                     }
    //                 });
    //             }

    //             rotationNames.forEach((itemMenu, index) => {
    //                 itemMenu.addEventListener('click', (e) => {
    //                     e.preventDefault();
    //                     activeTab(index);
    //                 }, { passive: true });
    //             });

    //             // Initial update for the first active tab
    //             activeTab(0);
    //         }
    //     }

    //     $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    //         Blazy({
    //             selector: '.lazy-img',
    //             successClass: 'loaded-img',
    //             success: function (element) {
    //                 setTimeout(function () {
    //                     var parent = element.previousSibling;
    //                     try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
    //                 }, 200);
    //             }
    //         });
    //     });
    // });

    waitForElementToExist('#rotation-vitrine1').then(function (element) {
      if (!element) {
          return;
      }

      var carouselIds = [
          '#carrousel-product-list',
          '#carrousel-product-list2',
          '#carrousel-product-list3',
          '#carrousel-product-list4',
          '#carrousel-product-list5'
      ];

      var rotationNames = Array.prototype.slice.call(
          element.querySelectorAll(
              '.vitrines-select .vitrines-select-name'
          )
      );

      var initVitrine = Array.prototype.slice.call(
          element.querySelectorAll(
              '.vitrines-products .vitrines-products-item'
          )
      );

      var $countFirst = $('.count-content .count-first');
      var $countEnd = $('.count-content .count-end');

      function formatCount(value) {
          return String(value).padStart(2, '0');
      }

      function updateCount(slick, currentSlide) {
          $countFirst.text(formatCount(currentSlide + 1));
          $countEnd.text(formatCount(slick.slideCount));
      }

      /*
       * Ativa a primeira vitrine antes de inicializar o Slick.
       * Isso permite que ele calcule corretamente as dimensões.
       */
      if (rotationNames.length && initVitrine.length) {
          initVitrine.forEach(function (content) {
              content.classList.remove('active');
          });

          rotationNames.forEach(function (menuItem) {
              menuItem.classList.remove('active');
          });

          initVitrine[0].classList.add('active');
          rotationNames[0].classList.add('active');

          $('.count').addClass('count-1');
      }

      /*
       * Inicialização dos carrosséis.
       */
      carouselIds.forEach(function (carouselId, index) {
          var $carousel = $(carouselId);
          var suffix = index === 0 ? '' : index + 1;

          if (!$carousel.length || $carousel.hasClass('slick-initialized')) {
              return;
          }

          $carousel.slick({
              arrows: true,
              prevArrow: $('.count .count-prev' + suffix),
              nextArrow: $('.count .count-next' + suffix),
              dots: false,
              infinite: false,
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 700,
              responsive: [
                  {
                      breakpoint: 992,
                      settings: {
                          infinite: true,
                          slidesToShow: 4,
                          slidesToScroll: 1
                      }
                  }
              ]
          });
      });

      function activeTab(index) {
          var carouselId = carouselIds[index];
          var $carousel = $(carouselId);

          if (
              !initVitrine[index] ||
              !rotationNames[index] ||
              !$carousel.length
          ) {
              return;
          }

          initVitrine.forEach(function (content) {
              content.classList.remove('active');
          });

          rotationNames.forEach(function (menuItem) {
              menuItem.classList.remove('active');
          });

          initVitrine[index].classList.add('active');
          rotationNames[index].classList.add('active');

          /*
           * Remove somente classes como count-1, count-2 etc.
           */
          $('.count')
              .removeClass(function (_, className) {
                  return (
                      className.match(/(^|\s)count-\d+/g) || []
                  ).join(' ');
              })
              .addClass('count-' + (index + 1));

          /*
           * Remove os eventos antigos do contador.
           */
          carouselIds.forEach(function (id) {
              $(id).off('afterChange.vitrineCount');
          });

          if (!$carousel.hasClass('slick-initialized')) {
              $countFirst.text('00');
              $countEnd.text('00');
              return;
          }

          $carousel.on(
              'afterChange.vitrineCount',
              function (event, slick, currentSlide) {
                  updateCount(slick, currentSlide);
              }
          );

          /*
           * Espera a vitrine ficar visível antes de recalcular o Slick.
           */
          setTimeout(function () {
              $carousel.slick('setPosition');

              var slick = $carousel.slick('getSlick');

              updateCount(slick, slick.currentSlide);
          }, 0);
      }

      rotationNames.forEach(function (itemMenu, index) {
          itemMenu.addEventListener('click', function (event) {
              event.preventDefault();
              activeTab(index);
          });
      });

      /*
       * Configura o contador e recalcula o primeiro carrossel.
       */
      activeTab(0);

      /*
       * Lazy loading depois de trocar o slide.
       */
      $(carouselIds.join(', ')).on(
          'afterChange.lazyImages',
          function () {
              Blazy({
                  selector: '.lazy-img',
                  successClass: 'loaded-img',
                  success: function (imageElement) {
                      setTimeout(function () {
                          var parent = imageElement.previousSibling;

                          try {
                              parent.className = parent.className.replace(
                                  /\bproduct-item__image--loading\b/,
                                  ''
                              );
                          } catch (error) {
                              // O elemento anterior pode não existir.
                          }
                      }, 200);
                  }
              });
          }
      );
  });

    waitForElementToExist('#rotation-vitrine2').then(element => {
        $('#carrousel-product-list6').slick({
            arrows: true,
            prevArrow: $(".count .count-prev6"),
            nextArrow: $(".count .count-next6"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list7').slick({
            arrows: true,
            prevArrow: $(".count .count-prev7"),
            nextArrow: $(".count .count-next7"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list8').slick({
            arrows: true,
            prevArrow: $(".count .count-prev8"),
            nextArrow: $(".count .count-next8"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list9').slick({
            arrows: true,
            prevArrow: $(".count .count-prev9"),
            nextArrow: $(".count .count-next9"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list10').slick({
            arrows: true,
            prevArrow: $(".count .count-prev10"),
            nextArrow: $(".count .count-next10"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list6',
                        '#carrousel-product-list7',
                        '#carrousel-product-list8',
                        '#carrousel-product-list9',
                        '#carrousel-product-list10',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list6, #carrousel-product-list7, #carrousel-product-list8, #carrousel-product-list9, #carrousel-product-list10').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#rotation-vitrine3').then(element => {
        $('#carrousel-product-list11').slick({
            arrows: true,
            prevArrow: $(".count .count-prev11"),
            nextArrow: $(".count .count-next11"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list12').slick({
            arrows: true,
            prevArrow: $(".count .count-prev12"),
            nextArrow: $(".count .count-next12"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list13').slick({
            arrows: true,
            prevArrow: $(".count .count-prev13"),
            nextArrow: $(".count .count-next13"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list14').slick({
            arrows: true,
            prevArrow: $(".count .count-prev14"),
            nextArrow: $(".count .count-next14"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });
        $('#carrousel-product-list15').slick({
            arrows: true,
            prevArrow: $(".count .count-prev15"),
            nextArrow: $(".count .count-next15"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list11',
                        '#carrousel-product-list12',
                        '#carrousel-product-list13',
                        '#carrousel-product-list14',
                        '#carrousel-product-list15',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list11, #carrousel-product-list12, #carrousel-product-list13, #carrousel-product-list14, #carrousel-product-list15').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });

    });

    waitForElementToExist('.banner-esport').then(element => {
        if (element) {
            $('#banner-esport-carrousel').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    }
                ]
            });
        }
    })

    const brands = document.querySelector('#brands-carousel');
    if (brands) {
        $('#brands-carousel').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                        speed: 1000,
                    },
                }
            ]
        });
    }
})